export const FORM_BUTTON_ALIGN_OPTIONS = [
  { value: 'text-left', name: 'form.button.align.options.left' },
  { value: 'text-center', name: 'form.button.align.options.center' },
  { value: 'text-right', name: 'form.button.align.options.right' },
  { value: 'full-width', name: 'form.button.align.options.full-width' },
]

export const defaultSettings = {
  fullWidth: false,
  fields: [
    {
      required: true,
      disabled: false,
      name: 'email',
      defaultLabel: 'blocks.form.fields.email.label',
      label: '',
      default: true,
    },
    {
      required: false,
      disabled: true,
      name: 'first_name',
      defaultLabel: 'blocks.form.fields.first_name.label',
      label: '',
      default: true,
    },
    {
      required: false,
      disabled: true,
      name: 'last_name',
      defaultLabel: 'blocks.form.fields.last_name.label',
      label: '',
      default: true,
    },
    {
      required: false,
      disabled: true,
      name: 'sms_number',
      defaultLabel: 'blocks.form.fields.sms.label',
      label: '',
      default: true,
    },
  ],
  fields_height: '40',
  fields_borderRadius: '6',
  fields_borderWidth: '1',
  fields_background: '#ffffff',
  fields_color: '#182026',
  fields_borderColor: '#dddddd',
  button: {
    text: 'blocks.form.button.default.text',
    width: '220',
    height: '40',
    fontSize: '14',
    borderRadius: '3',
    backgroundColor: '#444444',
    textColor: '#ffffff',
    align: FORM_BUTTON_ALIGN_OPTIONS[1].value,
  },
}

export const getDefaultContent = (
  formatMessage
) => `<div style="padding: 0px 40px;">

</div>`
